var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59693 16.7263H1.54594C1.44144 16.7265 1.33792 16.7061 1.2413 16.6663C1.14469 16.6265 1.05688 16.5681 0.982898 16.4942C0.908918 16.4204 0.850225 16.3327 0.810177 16.2362C0.77013 16.1397 0.749511 16.0362 0.749512 15.9317V1.54344C0.749511 1.43894 0.77013 1.33563 0.810177 1.23911C0.850225 1.14259 0.908918 1.05488 0.982898 0.981074C1.05688 0.907268 1.14469 0.848687 1.2413 0.808868C1.33792 0.769048 1.44144 0.748779 1.54594 0.749026H8.7869C8.89127 0.748934 8.99464 0.769363 9.0911 0.809234C9.18757 0.849105 9.27523 0.907497 9.34908 0.981257L12.6866 4.31887C12.7603 4.39272 12.8188 4.48044 12.8587 4.5769C12.8986 4.67336 12.9191 4.77668 12.919 4.88105V10.2573",
    stroke: "#4A90E2",
    strokeWidth: 1.49916,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1123 0.749023V5.02726H12.9227",
    stroke: "#4A90E2",
    strokeWidth: 1.49916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5425 17.489L9.87964 18.2498L10.6405 15.587L16.3485 9.87891L18.2506 11.781L12.5425 17.489Z",
    stroke: "#4A90E2",
    strokeWidth: 1.49916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.ee6a2a16d787125de8a8e532178b2010.svg";
export { ForwardRef as ReactComponent };